var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90925 11.3569C8.52308 10.9707 7.98642 10.7724 7.44275 10.8138C6.412 10.8937 5.35442 10.5397 4.56633 9.75158C3.85292 9.03758 3.49883 8.10425 3.49883 7.16975C3.49883 6.81742 3.549 6.46508 3.64933 6.12442L5.84908 8.32417C6.96442 8.56742 8.56275 6.95158 8.32358 5.84967L6.125 3.64992C6.46508 3.55017 6.81742 3.5 7.16917 3.5C8.10425 3.5 9.037 3.8535 9.75217 4.5675C10.5397 5.35558 10.8937 6.41317 10.8138 7.44333C10.7718 7.98758 10.9702 8.52425 11.3563 8.90983L13.0148 10.5682C13.6366 9.52233 14 8.30492 14 7C14 3.13425 10.8657 0 7 0C3.13425 0 0 3.13425 0 7C0 10.8657 3.13425 14 7 14C8.30433 14 9.52175 13.6366 10.5671 13.0153L8.90925 11.3569V11.3569Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUtility);
export default __webpack_public_path__ + "static/media/icon-utility.a44540b44b684b97b99c170e7c8f0b27.svg";
export { ForwardRef as ReactComponent };